module.exports = __webpack_public_path__ + "static/media/LogoDesktop.7998c252.svg";